<template>
  <div>
    <div class="content">
      <span style="font-size: 32px;">总访问量：<span style="color: #E6A23C;">{{ webcount.webCount }}</span>，今日访问量：<span style="color: #E6A23C;">{{ webcount.userCount }}</span></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webcount: {
        webCount: 0,
        userCount: 0
      }
    }
  },
  created() {
    this.loadCountData();
  },
  methods: {
    async loadCountData() {
      const { data: res } = await this.$http.get("user/load/webcount");
      if (res.code == 0) {
        this.webcount = res.data;
      }
    },
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 300px;
  text-align: center;
  margin-top: 200px;
}
</style>